module.exports = __webpack_public_path__ + "static/media/E-01.bc49b38a.webp";